import React from 'react';
import { SparklesIcon, UserIcon } from '@heroicons/react/24/outline';
import ApercuProduit from './ApercuProduit';

/**
 * Bulle de conversation. L'utilisateur est aligné à droite sur fond bleu,
 * l'assistant à gauche sur fond clair avec un avatar pour distinguer les tours.
 * `message` : { role: 'user' | 'assistant', content, productPreview? }
 */
const BulleMessage = ({ message }) => {
  const estUtilisateur = message.role === 'user';
  return (
    <div className={`flex gap-3 ${estUtilisateur ? 'flex-row-reverse' : 'flex-row'}`}>
      <div
        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${
          estUtilisateur ? 'bg-gray-200 text-gray-600' : 'bg-primary-600 text-white'
        }`}
        aria-hidden="true"
      >
        {estUtilisateur ? <UserIcon className="h-4 w-4" /> : <SparklesIcon className="h-4 w-4" />}
      </div>
      <div className={`max-w-[80%] ${estUtilisateur ? 'text-right' : 'text-left'}`}>
        <p className="mb-1 text-[11px] font-medium uppercase tracking-wide text-gray-400">
          {estUtilisateur ? 'Vous' : 'Assistant'}
        </p>
        <div
          className={`inline-block rounded-2xl px-4 py-2.5 text-left text-sm leading-relaxed ${
            estUtilisateur
              ? 'rounded-tr-sm bg-primary-600 text-white'
              : 'rounded-tl-sm border border-gray-200 bg-gray-50 text-gray-800'
          }`}
        >
          <div className="whitespace-pre-wrap">{message.content}</div>
          {/* La photo et les variantes rendent la validation du SKU explicite avant le brouillon. */}
          {message.productPreview && <ApercuProduit produit={message.productPreview} />}
        </div>
      </div>
    </div>
  );
};

export default BulleMessage;
